
// These names are in English
export const frictionInstruments: { [key: string]: string } = {
    BRD: 'Brakemeter-Dynometer',
    GRT: 'Grip Tester',
    MUM: 'Mu-meter',
    RFT: 'Runway friction tester',
    SFH: 'Surface friction tester (high pressure tires)',
    SFL: 'Surface friction tester (low pressure tires)',
    SKH: 'Skiddometer (high pressure tires)',
    SKL: 'Skiddometer (low pressure tires)',
    TAP: 'Tapleymeter'
}


export const contaminationCodes: { [key: number]: string } = {
    1: 'Damp',
    2: 'Wet or water patches',
    3: 'Rime (normally less than mm deep)',
    4: 'Dry snow',
    5: 'Wet snow',
    6: 'Slush',
    7: 'Ice',
    8: 'Compact or rolled snow',
    9: 'Frozen ruts or ridges',
}